window.addEventListener('load', function () {
	var switches = document.querySelectorAll('.section-switch');

	if (switches.length === 0) {
		return;
	}

	// Add the event listeners for the switch buttons
	Array.prototype.forEach.call(switches, function (switchEl) {

		// Find the sections that are controlled by this switch
		var btns = switchEl.querySelectorAll('button');
		if (!btns || !btns.length) {
			// No buttons in this switch
			return;
		}

		var sections = {};
		Array.prototype.forEach.call(btns, function(btn) {
			var sectionId = btn.getAttribute('aria-controls');
			var section = !sectionId ? null : document.getElementById(sectionId);
			if (section) {
				sections[sectionId] = section;
			}
		});
		if (!Object.keys(sections).length) {
			// No sections found to show and hide
			return;
		}

		// Add a handler to be able to switch with the arrow keys
		// when the switch has focus
		switchEl.addEventListener('keydown', function(e) {
			var focussedBtnIndex = Array.prototype.indexOf.call(btns, document.activeElement);
			if (focussedBtnIndex < 0) {
				return;
			}
			if (e.keyCode === 39) { // Arrow right
				btns[++focussedBtnIndex % btns.length].focus();
			}
			if (e.keyCode === 37) { // Arrow left
				btns[(--focussedBtnIndex + btns.length) % btns.length].focus();
			}
		})

		// Now set the listeners
		Array.prototype.forEach.call(btns, function(btn) {
			btn.addEventListener('click', function() {
				Array.prototype.forEach.call(btns, function(b) {
					b.setAttribute('aria-pressed', b === btn);
					b.setAttribute('aria-expanded', 'false');
				});
				for (var sectionId in sections) {
					sections[sectionId].style.display = 'none';
				}

				sectionId = this.getAttribute('aria-controls');
				if (!sectionId || !sections[sectionId]) {
					return;
				}

				sections[sectionId].style.display = 'block';
				this.setAttribute('aria-expanded', true);
			});
		});
	});
});
